import type { IAuthFormBoxProps } from './AuthFormBox'

import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { InputSC } from 'atoms/Input'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS, MEDIA } from 'vars/index'
import {
  AuthFormBoxBackgroundColors,
  AuthFormBoxDirection,
} from './AuthFormBox.h'

export const FieldLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const LoginColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > :nth-child(1) {
    width: 100%;
  }
`

export const SubmitForm = styled.div`
  display: flex;
  gap: 10px;
  padding-top: 12px;
`

export const AuthFormBoxStyled = styled.div<IAuthFormBoxProps>`
  width: calc(
    100vw - 56px
  ); // 56px this distance from the page border by mockup
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  display: flex;
  flex-direction: ${({ direction }) =>
    direction || AuthFormBoxDirection.Column};
  justify-content: ${({ justifyContent }) => justifyContent || 'initial'};
  align-items: ${({ alignItems }) => alignItems || 'initial'};
  background: var(${AuthFormBoxBackgroundColors.TRANSPARENT});
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 0)};

  & ${TextBoxSC} {
    overflow: hidden;
  }

  & ${InputSC} {
    min-height: 40px;
  }

  // Styles if submit form added inside AuthFormBox
  & > form:nth-child(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    & > :nth-child(1) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[0] || FIXED_INDENTS.INDENT_0})`};
    }

    & > :nth-child(2) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[1] || FIXED_INDENTS.INDENT_0})`};
    }

    & > :nth-child(3) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[2] || FIXED_INDENTS.INDENT_0})`};
    }

    & > :nth-child(4) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[3] || FIXED_INDENTS.INDENT_0})`};
    }

    & > :nth-child(5) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[4] || FIXED_INDENTS.INDENT_0})`};
    }

    & > :nth-child(6) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[5] || FIXED_INDENTS.INDENT_0})`};
    }

    & > :nth-child(7) {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[6] || FIXED_INDENTS.INDENT_0})`};
    }

    & + * {
      margin-bottom: ${({ rowGap }) =>
        `var(${rowGap?.[5] || FIXED_INDENTS.INDENT_0})`};
    }
  }

  // Styles if submit form wraps AuthFormBox
  & > :nth-child(1) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[0] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :nth-child(2) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[1] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :nth-child(3) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[2] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :nth-child(4) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[3] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :nth-child(5) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[4] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :nth-child(6) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[5] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :nth-child(7) {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[6] || FIXED_INDENTS.INDENT_0})`};
  }

  & > :last-child:not(${ButtonSC}) {
    margin-bottom: 0;
  }

  ${MEDIA.MIN_600} {
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
    padding: ${({ padding }) =>
      padding && padding.length > 0
        ? padding.map((item) => `var(${item})`)?.join(' ')
        : 0};
    background-color: ${({ backgroundColorDefault }) =>
      `var(${backgroundColorDefault})`};
  }
`

export const RememberMeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
